import { Divider, Typography, TypographyProps } from "@mui/material";
import i18nPackage from "../../i18n/i18n";

type CoreDividerWithTextProps = {
	children?: string;
	className?: string;
	dividerClassName?: string;
	orientation?: "horizontal" | "vertical";
} & Omit<TypographyProps, "children" | "className" | "component">;

export default function CoreDividerWithText({
	children = i18nPackage.t("coreComponents.divider.OR"),
	dividerClassName,
	className,
	orientation = "horizontal",
	...props
}: CoreDividerWithTextProps) {
	return (
		<Divider role="separator" className={dividerClassName} aria-label={children} orientation={orientation}>
			<Typography {...props} component="span" className={className}>
				{children}
			</Typography>
		</Divider>
	);
}
